export const zimoThemeColors = {
  primary: '#4C00D7',
  secondary: '#4C00D7',
  tertiary: '#B3B3FF',
  h1: {
    color: '#233db4',
    fontSize: '30px',
    lineHeight: '1.27',
    fontFamily: '"Archivo", sans-serif',
  },
  success: '#23233F',
  info: '#3BCFD5',
  warning: '#F3B258',
  danger: '#DD3570',
  dark: '#FFFFFF',
  activeColor: '#FFFFFF',
  contrastActiveColor: '#000000',
  loaderFirst: '#4C00D7',
  loaderSecond: '#7DF4EB',
  loaderThird: '#B3B3FF',
  borderColor: '#FF0095',
  roundedGrey: '#F3F3FF',
};
